const PERCENTAGE_FORMATTER = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
  minimumFractionDigits: 0,
})

export function formatPercentage(value: number): string {
  return PERCENTAGE_FORMATTER.format(value)
}
